const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReactRouter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#62d9fb",
    d: "M 292.5,135.5 C 327.734,133.237 349.568,149.237 358,183.5C 360.215,192.788 362.215,202.121 364,211.5C 366.501,223.331 373.335,231.498 384.5,236C 400.462,238.829 416.462,241.496 432.5,244C 462.956,249.382 479.289,267.548 481.5,298.5C 479.749,327.074 465.083,344.907 437.5,352C 422.254,354.986 406.921,357.319 391.5,359C 378.932,361.902 370.432,369.402 366,381.5C 363.44,393.862 360.773,406.196 358,418.5C 348.94,445.366 330.273,460.033 302,462.5C 263.886,458.059 245.553,436.725 247,398.5C 254.07,370.773 271.904,354.94 300.5,351C 313.195,349.513 325.861,347.846 338.5,346C 349.888,343.225 357.721,336.392 362,325.5C 368.34,304.219 366.673,283.553 357,263.5C 350.231,255.697 341.731,250.864 331.5,249C 312.255,248.127 293.589,244.46 275.5,238C 253.393,225.284 243.893,206.118 247,180.5C 252.799,155.867 267.966,140.867 292.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#414141",
    d: "M 179.5,243.5 C 214.415,245.415 233.748,263.748 237.5,298.5C 234.13,331.87 215.797,350.203 182.5,353.5C 149.166,350.166 130.833,331.833 127.5,298.5C 130.554,266.451 147.887,248.118 179.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#414141",
    d: "M -0.5,417.5 C -0.5,410.833 -0.5,404.167 -0.5,397.5C 9.23915,363.946 31.5725,349.446 66.5,354C 98.4594,364.729 111.959,386.895 107,420.5C 98.681,446.581 80.8477,460.581 53.5,462.5C 25.0662,459.713 7.06622,444.713 -0.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#414141",
    d: "M 599.5,398.5 C 599.5,404.5 599.5,410.5 599.5,416.5C 592.319,444.337 574.319,459.67 545.5,462.5C 518.338,461.003 500.504,447.336 492,421.5C 487.106,397.173 494.273,377.339 513.5,362C 537.689,348.139 560.689,349.806 582.5,367C 591.073,376.037 596.74,386.537 599.5,398.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactRouter);
export default __webpack_public_path__ + "static/media/react-router.9d755ffc314312436ca7c5ec4fda7632.svg";
export { ForwardRef as ReactComponent };